import i18next from 'i18next';

export const cohorts: Record<number, string> = {
  1: i18next.t('cohorts.1'),
  2: i18next.t('cohorts.2'),
  3: i18next.t('cohorts.3'),
  4: i18next.t('cohorts.4'),
  5: i18next.t('cohorts.5'),
  6: i18next.t('cohorts.6'),
  7: i18next.t('cohorts.7'),
  8: i18next.t('cohorts.8'),
  9: i18next.t('cohorts.9'),
};
